import { render } from "./SegmentedControls.vue?vue&type=template&id=ad683a7c&ts=true"
import script from "./SegmentedControls.vue?vue&type=script&lang=ts"
export * from "./SegmentedControls.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__